module.exports = __webpack_public_path__ + "img/payroll-sample.ad36c3f8.png";